/**
 * 코드 → 화면 라벨.
 *
 * 저장되는 값은 <b>코드</b>이고 여기 라벨은 화면 표시 전용이다.
 *
 * 예전엔 화면이 보낸 한글 문자열("반차(오전)")이 그대로 저장됐고, 서버는 그 문자열을
 * exact match 로 판정했다. 그래서 "반차(오전)" 은 어느 case 에도 안 걸려 연차 차감이 0이 됐는데
 * 캘린더는 startsWith 로 알아봐서 휴가는 정상으로 떴다 — 화면상 멀쩡해 보이는 어긋남이었다.
 * 코드로 주고받으면 라벨을 뭘로 바꾸든 그 어긋남이 생기지 않는다.
 */
export const LEAVE_KIND_LABEL = {
    ANNUAL:   "연차",
    HALF_AM:  "오전 반차",
    HALF_PM:  "오후 반차",
    QUARTER:  "반반차",
    COMP_DAY: "대체휴무",
    SICK:     "병가",
};

/** 하루치 차감 시간 — 화면에서 "며칠 차감되는지" 미리 보여줄 때 쓴다. 서버 계산과 같은 규칙. */
export const LEAVE_KIND_HOURS = {
    ANNUAL:   8,
    HALF_AM:  4,
    HALF_PM:  4,
    QUARTER:  2,
    COMP_DAY: 8,
    SICK:     8,
};

/** 하루 단위로 세는 종류 — 반차 계열은 기간을 곱하지 않는다. */
export const LEAVE_KIND_FULL_DAY = ["ANNUAL", "COMP_DAY", "SICK"];

export const COMPENSATION_LABEL = {
    COMP_DAY: "대체휴무",
    CASH:     "휴일수당",
};
